import React, { useState } from "react";
import SideMenu from "./../../../sharedScreens/menuItems/SideMenu";
import { MuiInput } from "./../../../components/basicComponent/MuiInput";
import MuiButton from "./../../../components/basicComponent/MuiButton";
import MuiSearchSelect from "./../../../components/basicComponent/MuiSearchSelect";
import Header from "./../../../sharedScreens/Header";
import MuiDatePicker from "../../../components/basicComponent/MuiDatePicker";

const EasyPayment = () => {
  const [active, setActive] = useState<Boolean>(false);
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header flex-wrap">
              <h3 className="card-title">Easy Payment</h3>
              <div>
                <button
                  className="fliter-btn"
                  onClick={() => {
                    setActive(!active);
                  }}
                >
                  {active ? "View " : "New"}
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    {active && (
                      <div className="row mt-2">
                        <div className="col-md-4 mt-3">
                          <MuiSearchSelect
                            placeholder={"Business unit "}
                            label="Business unit "
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>
                        <div className="col-md-4 mt-3">
                          <MuiSearchSelect
                            placeholder={"Customer Name"}
                            label="Customer Name "
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>

                        <div className="col-md-4 mt-3">
                          <MuiSearchSelect
                            placeholder={"User Name"}
                            label="User Name"
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>
                        <div className="col-md-4 mt-3">
                          <MuiInput label={"Amount "} placeholder="Amount " />
                        </div>
                        <div className="col-md-4 mt-3">
                          <MuiInput
                            label={"Email ID "}
                            placeholder="Email ID "
                          />
                        </div>
                        <div className="col-md-4 mt-3">
                          <MuiInput
                            label={"Mobile No"}
                            placeholder="Mobile No"
                          />
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                            marginTop: "8px",
                          }}
                        >
                          <div className="user-button w-full">
                            <MuiButton className="clear-btn " label="Clear" />
                            <MuiButton
                              className="main-btn get-btn"
                              variant="contained"
                              size="large"
                              type="submit"
                              label={"Submit"}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {!active && (
                      <div className="row mt-2">
                        <div className="col-md-4 mt-3">
                          <MuiSearchSelect
                            placeholder={"Customer Name "}
                            label="Customer Name  "
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>
                        <div className="col-md-4 mt-3">
                          <MuiInput label={"S PNR"} placeholder="S PNR" />
                        </div>

                        <div className="col-md-4 mt-3">
                          <MuiInput
                            label={"Airline PNR"}
                            placeholder="Airline PNR"
                          />
                        </div>

                        <div className="col-md-4 mt-3">
                          <MuiDatePicker
                            label="From Date"
                            value={null}
                            onChange={function (date: string): void {
                              throw new Error("Function not implemented.");
                            }}
                          />
                        </div>
                        <div className="col-md-4 mt-3">
                          <MuiDatePicker
                            label="To Date"
                            value={null}
                            onChange={function (date: string): void {
                              throw new Error("Function not implemented.");
                            }}
                          />
                        </div>
                        <div className="col-md-4 mt-3">
                          <MuiSearchSelect
                            placeholder={"Status "}
                            label="Status"
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>
                        <div className="col-md-4 mt-3">
                          <MuiInput
                            label={"Track ID "}
                            placeholder="Track ID "
                          />
                        </div>
                        <div className="col-md-4 mt-3">
                          <MuiInput label={"Email ID"} placeholder="Email ID" />
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                            marginTop: "8px",
                          }}
                        >
                          <div className="user-button w-full">
                            <MuiButton className="clear-btn " label="Clear" />
                            <MuiButton
                              className="main-btn get-btn"
                              variant="contained"
                              size="large"
                              type="submit"
                              label={"Get"}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default EasyPayment;
